import React, { useEffect, useRef, useState } from "react";
import { ProgressBar } from "react-bootstrap";

interface AnimatedProgressBarProps {
  skillScore: number;
}

const AnimatedProgressBar: React.FC<AnimatedProgressBarProps> = ({
  skillScore,
}) => {
  const [progress, setProgress] = useState(0);
  const barRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let observer: IntersectionObserver | null = null;

    if (barRef.current) {
      observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            let start = 0;
            const duration = 1000;
            const increment = skillScore / (duration / 10);

            const interval = setInterval(() => {
              start += increment;
              if (start >= skillScore) {
                start = skillScore;
                clearInterval(interval);
              }
              setProgress(Math.round(start));
            }, 10);

            // ✅ disconnect observer immediately after animation starts
            if (observer && barRef.current) {
              observer.unobserve(barRef.current);
              observer.disconnect();
            }
          }
        },
        { threshold: 0.3 },
      );

      observer.observe(barRef.current);
    }

    return () => {
      if (observer) observer.disconnect();
    };
  }, [skillScore]);

  return (
    <div ref={barRef}>
      <ProgressBar className="progressBarReport" now={progress} />
    </div>
  );
};

export default AnimatedProgressBar;
